import { BsPersonUp } from 'react-icons/bs';

// ==============================|| UTILITIES MENU ITEMS ||============================== //

const suppliers = {
  id: 'suppliers',
  title: '',
  type: 'group',
  children: [
    {
      id: 'suppliers-management',
      title: 'Sponsors',
      type: 'item',
      url: '/suppliers',
      icon: BsPersonUp,
      allowedRoles: ['admin', 'superAdmin'],
      breadcrumbs: false
    }
  ]
};

export default suppliers;
